<template>
  <!-- eslint-disable max-len -->
  <div>
    <Banner
      v-if="showOutageBanner"
      class="c-banner--alert"
      role="alert"
    >
      <span class="font-bold block">THE USPS® CHANGE OF ADDRESS WEBSITE IS TEMPORARILY UNAVAILABLE.</span>
      We are currently unable to service your online Change-of-Address. We apologize for the inconvenience, please try again later.
    </Banner>
    <Banner
      v-if="showUpcomingMaintenanceBanner"
      class="c-banner--alert"
      role="alert"
    >
      {{ showUpcomingMaintenanceBanner }}
    </Banner>
    <main
      id="main"
      ref="main"
      class="bg-white"
    >
      <header
        id="hero"
        class="bg-blue-200"
      >
        <div class="px-6 py-8">
          <h1 class="text-white mb-4">
            Official USPS<sup>®</sup><br>Change-of-Address
          </h1>
          <p class="text-white mb-4">
            By clicking Get Started, I understand and acknowledge the statements below.
          </p>
          <router-link
            v-if="!showOutageBanner"
            id="get-started-top"
            ref="headerGetStarted"
            :to="{ name: handleNavigation }"
            class="c-btn--ghost"
            @click.native="getStarted"
          >
            Get Started
          </router-link>
        </div>
      </header>
      <div id="exp-value-props" />
      <section class="p-6">
        <p class="mb-4">
          <strong>Note:</strong>
          The person who prepares this form states that he or she is the person, executor, guardian, authorized officer, or agent of the person for whom mail would be forwarded under this order. Anyone submitting false or inaccurate information on this form is subject to punishment by fine or imprisonment or both under Sections 2, 1001, 1702 and 1708 of Title 18, United States Code.
        </p>
        <a
          ref="privacyPolicy"
          class="c-link--inline pr-4"
          href="https://about.usps.com/who/legal/privacy-policy/full-privacy-policy.htm"
          target="_blank"
          rel="noopener noreferrer"
        >Privacy Policy</a>
        <router-link
          ref="termsOfUse"
          :to="{ name: 'terms-of-use' }"
          target="_blank"
          class="c-link--inline"
        >
          <span>Terms of Use</span>
        </router-link>
        <p class="mt-4">
          <strong>Note:</strong> For your security, we need to verify your identity using a valid credit or debit card. You will be charged {{ icoaAmountFormatted }} for this service.
        </p>
      </section>
      <div
        ref="coacLinksBanner"
        class="w-screen bg-blue-200"
      >
        <div class="flex items-center u-container--x py-6">
          <div class="mr-2 text-xl text-white">
            <a
              id="view-edit-coac"
              :href="$options.coacUrl"
              title="Official USPS Change-of-Address Correct Form"
              class="font-bold"
            >
              Manage your Change-of-Address® on managemymove.com
            </a>
          </div>
          <div class="w-4 not-sr-only">
            <a
              :href="$options.coacUrl"
              title="Official USPS Change-of-Address Correct Form"
            >
              <span class="red-arrow" />
            </a>
          </div>
        </div>
      </div>
      <div class="mt-10">
        <p class="disclaimer-mobile__get-started-text">
          By clicking Get Started, I understand and acknowledge the statements below.
        </p>
        <router-link
          v-if="!showOutageBanner"
          id="get-started-body"
          ref="ctaGetStarted"
          :to="{ name: handleNavigation }"
          class="c-btn w-full rounded-none"
          @click.native="getStarted"
        >
          Get Started
        </router-link>
      </div>
    </main>
  </div>
</template>

<script>
import { Banner } from '@mgo/ui/lib/components';
import { mobileAnalytics } from '../MoveCombined/analytics';
import pageView from '../../mixins/pageView';
import destinationManager from '../../mixins/destinationManager';

export default {
  name: 'Disclaimer',
  components: { Banner },
  mixins: [pageView, destinationManager],
  computed: {
    analytics() {
      return mobileAnalytics();
    },
    coaDisputesEnabled() {
      return this.$store.get('config@coaDisputesEnabled') || false;
    },
    handleNavigation() {
      return this.showChoiceExperience ? 'address-info' : 'move-combined';
    },
    showChoiceExperience: () => JSON.parse(sessionStorage.getItem('showChoiceExperience')),
    flagAmpersendEnabled() {
      return this.$store.get('flagAmpersendEnabled');
    },
    icoaAmount() {
      return this.$store.get('config@icoaAmount') || 105;
    },
    icoaAmountFormatted() {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(this.icoaAmount / 100);
    },
    showOutageBanner() {
      return this.$store.get('flagOutageBanner');
    },
    showUpcomingMaintenanceBanner() {
      return this.$store.get('upcomingMaintenance');
    },
  },
  async mounted() {
    this.pageView();
  },
  methods: {
    getStarted() {
      this.analytics.click.getStarted();

      if (this.flagAmpersendEnabled) {
        this.$amp.identify({
          offersOptIn: (JSON.parse(sessionStorage.getItem('mmco')) ?? this.offersChoice) || false,
          voterregOptIn: (JSON.parse(sessionStorage.getItem('mmcvr')) ?? this.autofillChoice) || false,
        });
      }
    },
  },
};
</script>
